import { AlertV2 } from "@/components/ui-v2";

interface ProvisioningFlowHintProps {
  title: string;
  body: string;
}

export function ProvisioningFlowHint({
  title,
  body,
}: ProvisioningFlowHintProps) {
  return (
    <AlertV2 variant="info" title={title}>
      {body}
    </AlertV2>
  );
}
